export default "__VITE_ASSET__D6D34Dh___"